$(document).on('click','.clickable-title',function(){
    $(this).closest('.clickable-cat-left').toggleClass('is-open');
})
var timeoutHandle;
$(document).on("mouseenter",".mainmenu > .ddown", function () {
    if($(window).width() >= 992){
        var _this = this;
        timeoutHandle = setTimeout(function(){ 
             $(_this).addClass('isHover');
         }, 300); 
    }
    
});
$(document).on("mouseleave",".mainmenu > .ddown", function () {
    if($(window).width() >= 992){
        var _this = this;
        clearTimeout(timeoutHandle);
        //setTimeout(function(){ 
            $(_this).removeClass('isHover');
        //}, 300);
    }
}); 

$(document).on('click','.btn-scroll-config',function(){
    $("html, body").animate({ scrollTop: $('.line-head-config').offset().top }, 1000);
})
$(document).on('click','.footer-clickable .h4',function(){
    $(this).closest('.footer-clickable-wrap').toggleClass('active');
})

$(document).on('click','.open-search',function(){
    $('.main-search').toggleClass('is-open');
    //$(".search-input").focus();
    //$(".search-input").focus();

    setTimeout(function(){
        if($('.main-search').hasClass('is-open')){
            $(".search-input").focus();
        }
        
    }, 300);
})

$(document).on('click','.config-list-item',function(){
    $('.config-list-item').removeClass('is-active');
    $(this).addClass('is-active');


    var mobilePath = $(this).data('mobileimg');
    var mobilePathFallback = $(this).data('mobileimgfallback');
    var desktopPath = $(this).data('desktopimg');
    var desktopPathFallback = $(this).data('desktopimgfallback');
    var configName = $(this).data('configname');
    var configUrl = $(this).data('configurl');
    var configText = $(this).data('configtext');

    $('.config-text-preview').html(configText);
    $('.config-btn-preview').attr('href', configUrl);

    $('.config-main-img-mobile').attr('srcset', mobilePath);
    $('.config-main-img-fallback-mobile').attr('srcset', mobilePathFallback);
    $('.config-main-img-desktop').attr('srcset', desktopPath);
    $('.config-main-img-fallback-desktop').attr('srcset', desktopPathFallback);
    $('.config-main-img-src').attr('src', mobilePathFallback);
    $('.config-main-img picture').attr('title', configName);
    $('.config-main-img picture').attr('alt', configName);
    $('.config-main-img img').attr('alt', configName);
    $('.config-main-img img').attr('title', configName);
    $('.mobile-dropdown-head span').html(configName);
    $(this).closest('.config-list-items').removeClass('dropdown-open');
})
$(document).on('click','.mobile-dropdown-head',function(){
    $(this).closest('.config-list-items').toggleClass('dropdown-open');
})

$(document).mouseup(function(e) 
{   
    if($(".config-list-items-container").length > 0){
        var container = $(".config-list-items-container");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            //console.log($(container).hasClass('cat-facet'))
            //if(!$(container).hasClass('cat-facet'))
            $(container).closest('.config-list-items').removeClass('dropdown-open');
        }
    }
    
});